'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const trackSize = require('./track-size.js');
const trackSizes = require('./track-sizes.js');



exports.trackElementSize = trackSize.trackElementSize;
exports.trackElementsSize = trackSizes.trackElementsSize;
